module.exports = __webpack_public_path__ + "webpc/img/icon_logo.8bb0a69d.png";